import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  error: false,
  prelivematches: {
    currentPage: "1",
    matches: [],
    hasNext: false,
    totalPage: 0,
    loading: false,
    success: false,
    isEmpty: false
  },
  livematches: {
    currentPage: "1",
    matches: [],
    hasNext: false,
    totalPage: 0,
    loading: false,
    success: false,
    isEmpty: false
  },
  currentFavMatchId: ""
};

const MatchesSlice = createSlice({
  name: "Matches",
  initialState,
  reducers: {
    getPreMatchesStart: (state, action) => {
      state.prelivematches.loading = action?.payload?.loadingFalse
        ? false
        : true;
      state.prelivematches.error = false;
    },
    getLiveMatchesStart: (state, action) => {
      state.livematches.loading = action?.payload?.loadingFalse ? false : true;
      state.livematches.error = false;
      state.livematches.success = false;
    },

    getMatchesSuccess: (state, action) => {
      let matches = [];
      let currentPage = parseInt(action?.payload?.data?.currentPage);
      let totalPage = parseInt(action?.payload?.data?.currentPage + 1);
      if (!action?.payload?.data?.matchList?.length && currentPage > 1) {
        totalPage = currentPage > 1 ? currentPage - 1 : 1;
        currentPage = currentPage > 1 ? currentPage - 1 : 1;
        if (action?.payload?.isLive) {
          matches = state.livematches.matches;
        } else {
          matches = state.prelivematches.matches;
        }
      }
      if (
        action?.payload?.data?.matchList?.length &&
        action?.payload?.data?.matchList?.length < 9
      ) {
        totalPage = currentPage > 1 ? currentPage - 1 : 1;
        currentPage = currentPage > 1 ? currentPage - 1 : 1;
      }

      if (action?.payload?.data?.matchList?.length) {
        matches = action?.payload?.data?.matchList?.map((match) => {
          const matchMarkets = {};
          const matchMarketIds = match?.matchMarkets?.map((market) => {
            matchMarkets[market?.matchMarketId] = market;

            return market?.matchMarketId;
          });
          return {
            ...match,
            matchMarkets,
            matchMarketIds
          };
        });
      }

      if (action?.payload?.isLive) {
        state.livematches = {
          currentPage: currentPage,
          hasNext: currentPage < totalPage,
          totalPage: totalPage,
          loading: false,
          success: true,
          matches: matches,
          isEmpty: !action?.payload?.data?.matchList?.length
        };
      } else {
        state.prelivematches = {
          currentPage: currentPage,
          hasNext: currentPage < totalPage,
          totalPage: totalPage,
          loading: false,
          success: true,
          matches: matches,
          isEmpty: !action?.payload?.data?.matchList?.length
        };
      }
    },
    getMatchesFailure: (state) => {
      state.prelivematches.loading = false;
      state.prelivematches.error = true;
      state.livematches.loading = false;
      state.livematches.error = true;
      state.prelivematches.isEmpty = false;
      state.livematches.isEmpty = false;
    },
    resetLiveMatches: (state) => {
      state.livematches = {
        currentPage: "1",
        matches: [],
        hasNext: false,
        totalPage: 0
      };
    },
    resetPreLiveMatches: (state) => {
      state.prelivematches = {
        currentPage: "1",
        matches: [],
        hasNext: false,
        totalPage: 0
      };
    },
    getReconnectionStart: (state, action) => {},
    getFavMatchSuccess: (state, action) => {
      let currentPage = parseInt(action?.payload?.data?.currentPage);
      let totalPage = parseInt(action?.payload?.data?.totalPage);

      const matches = action?.payload?.data?.matchList?.map((match) => {
        const matchMarkets = {};
        const matchMarketIds = match?.matchMarkets?.map((market) => {
          matchMarkets[market?.matchMarketId] = market;

          return market?.matchMarketId;
        });
        return {
          ...match,
          matchMarkets,
          matchMarketIds
        };
      });
      if (action?.payload?.isLive) {
        state.livematches = {
          currentPage: currentPage,
          hasNext: currentPage < totalPage,
          totalPage: totalPage,
          loading: false,
          success: true,
          matches: matches,
          isEmpty: !action?.payload?.data?.matchList?.length
        };
      } else {
        state.prelivematches = {
          currentPage: currentPage,
          hasNext: currentPage < totalPage,
          totalPage: totalPage,
          loading: false,
          success: true,
          matches: matches,
          isEmpty: !action?.payload?.data?.matchList?.length
        };
      }
    }
  }
});

export const {
  getPreMatchesStart,
  getLiveMatchesStart,
  getMatchesSuccess,
  getMatchesFailure,
  resetLiveMatches,
  resetPreLiveMatches,
  updateMatchWithSocketData,
  getReconnectionStart,
  getFavMatchSuccess
} = MatchesSlice.actions;

export default MatchesSlice.reducer;
